module.exports = __webpack_public_path__ + "img/海鲜干货大礼包.d71a0d1a.jpg";